module.exports = __webpack_public_path__ + "static/media/peghook4point.c6a0ad30.png";